import { cls } from "@wss/cls";
import React from "react";

interface AddToCartErrorMessageProps {
  errorMessage: string | undefined;
  isInStock: boolean;
}

const AddToCartErrorMessage = ({
  errorMessage,
  isInStock,
}: AddToCartErrorMessageProps) => {
  return (
    <p
      data-testid="error-message"
      className={cls(
        "mt-0",
        "pt-0",
        "mb-1",
        !isInStock && "-top-2",
        "messages",
        "xxl:flex",
        "xxl:justify-center",
      )}
      role="alert"
      aria-live="assertive"
    >
      {errorMessage}
    </p>
  );
};

export default AddToCartErrorMessage;
